export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#e5e2d8] pt-14 md:pt-16 pb-8"
    >
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        {/* Big brand wordmark */}
        <div>
          <div
            aria-hidden
            className="font-semibold tracking-tight leading-none select-none text-center md:text-left"
            style={{
              fontSize: "clamp(3rem, 16vw, 12rem)",
              background:
                "linear-gradient(180deg, rgba(10,10,10,0.18) 0%, rgba(10,10,10,0.03) 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            VIRALX MEDIA
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-[#e5e2d8] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[#0a0a0a]/40 text-[12px]">
          <div>© {new Date().getFullYear()} VIRALX MEDIA. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-[#0a0a0a]/70 transition-colors">Privacy</a>
            <a href="#" className="hover:text-[#0a0a0a]/70 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
